import React from "react";
import { Link } from "react-router-dom";

const RelatedPost = ({ relatedBlog }) => {
  const { id, title, image, tags, createdAt } = relatedBlog || {};
  let tagContent = null;
  tagContent = tags?.length > 0 && tags.map((tag) => `#${tag}`).join(`, `);

  return (
    <>
      {/* <!-- related post  --> */}
      <div className="card">
        <Link to={`/blogs/${id}`}>
          <img src={image} className="card-image" alt={title} />
        </Link>
        <div className="p-4">
          <Link
            to={`/blogs/${id}`}
            className="text-lg post-title lws-RelatedPostTitle"
          >
            {title}
          </Link>
          <div className="mb-0 tags">
            {/* <span>#python,</span> <span>#tech,</span> <span>#git</span> */}
            <span>{tagContent}</span>
          </div>
          <p>{createdAt}</p>
        </div>
      </div>
      {/* <!-- related post ends --> */}
    </>
  );
};

export default RelatedPost;
